import { render, staticRenderFns } from "./AlternateEmailForm.vue?vue&type=template&id=d3249870"
import script from "./AlternateEmailForm.vue?vue&type=script&lang=js"
export * from "./AlternateEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports